import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { Features } from './components/Features';
import { Testimonials } from './components/Testimonials';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
import { PawBackground } from './components/PawBackground';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfUse } from './pages/TermsOfUse';
import { ContactUs } from './pages/ContactUs';
import { DeleteAccount } from './pages/DeleteAccount';
import { CreatorProgram } from './pages/CreatorProgram';
function HomePage() {
  return <>
      <main data-id="element-0">
        <Hero data-id="element-1" />
        <HowItWorks data-id="element-2" />
        <Features data-id="element-3" />
        <Testimonials data-id="element-4" />
        <CallToAction data-id="element-5" />
      </main>
    </>;
}
export function App() {
  return <BrowserRouter data-id="element-6">
      <div className="min-h-screen bg-cream" data-id="element-7">
        <Navbar data-id="element-8" />
        <Routes data-id="element-9">
          <Route path="/" element={<HomePage data-id="element-11" />} data-id="element-10" />
          <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-13" />} data-id="element-12" />
          <Route path="/terms-of-use" element={<TermsOfUse data-id="element-15" />} data-id="element-14" />
          <Route path="/contact-us" element={<ContactUs data-id="element-17" />} data-id="element-16" />
          <Route path="/delete-account" element={<DeleteAccount data-id="element-19" />} data-id="element-18" />
          <Route path="/creator" element={<CreatorProgram data-id="element-21" />} data-id="element-20" />
        </Routes>
        <Footer data-id="element-22" />
      </div>
    </BrowserRouter>;
}